import { render, staticRenderFns } from "./CouponTemplates.vue?vue&type=template&id=27a8c0a1&"
import script from "./CouponTemplates.vue?vue&type=script&lang=js&"
export * from "./CouponTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports